export default {
  de: {
    title: 'Ziele',
  },
};
